// SidebarNewsList.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom"; // Import Link
import "./SidebarNewsList.css";

const SidebarNewsList = () => {
  // State to store all top news items from the API
  const [newsList, setNewsList] = useState([]);

  useEffect(() => {
    axios
      .get("https://khanehyeghtesad.com:8000/api/article/top/")
      .then((res) => {
        // Assuming res.data is the array of news items
        setNewsList(res.data);
      })
      .catch((err) => {
        console.error("Error fetching top articles:", err);
      });
  }, []);

  // Extract the first item as the "Most Viewed" news
  const firstItem = newsList[0];

  // Extract the next three items
  const nextThree = newsList.slice(1, 4);

  // Helper function to construct the image URL from Base64
  const getImageUrl = (base64String, imageType = "jpeg") => {
    if (!base64String) return "https://via.placeholder.com/300x200"; // Fallback image
    return `data:image/${imageType};base64,${base64String}`;
  };

  return (
    <div className="sidebar-news-list-container">
      {/* (1) "پربازدید" (Most Viewed) Block */}

      {firstItem && (
        <Link
          to={`/article/${firstItem.slug}`} // Navigate to the article page
          className="most-viewed-link" // Custom CSS class
        >
          <h3>اخبار پربازدید</h3>
          <div className="world-news-card">
            {/* Display Base64 Image */}
            <img
              src={getImageUrl(firstItem.image_file, firstItem.image_type)}
              alt={firstItem.title}
              className="world-news-image"
              loading="lazy"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://via.placeholder.com/300x200";
              }}
            />
            <div className="world-news-details">
            <p className="summary-category">{firstItem.quote}</p>
            <h4 className="world-news-title">
  {firstItem.title?.length > 100 
    ? firstItem.title.substring(0, 100) + "…" 
    : firstItem.title}
</h4>
              <p className="world-news-date">
                {firstItem.jalali_full_date || firstItem.date}
              </p>
            </div>
          </div>
        </Link>
      )}

      {/* (2) Next 3 News Items */}
      <div className="sidebar-news-list-latest">
        {nextThree.map((newsItem) => (
          <Link
            to={`/article/${newsItem.slug}`} // Navigate to the article page
            key={newsItem.slug}
            className="news-item-link-latest" // Custom CSS class
          >
            <div className="news-item-latest">
              {/* Display Base64 Thumbnail Image */}
              <img
                src={getImageUrl(newsItem.image_file, newsItem.image_type)}
                alt={newsItem.title}
                className="news-thumbnail-image-latest"
                loading="lazy"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://via.placeholder.com/100x100";
                }}
              />
              <div className="news-details-latest">
              <p className="summary-category">{newsItem.quote}</p>
              <h4 className="news-title-latest">
  {newsItem.title?.length > 100 
    ? newsItem.title.substring(0, 100) + "…" 
    : newsItem.title}
</h4>
                <p className="news-date-latest">
                  {newsItem.jalali_full_date || newsItem.date}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SidebarNewsList;
